import React from "react";
import { observer } from "mobx-react";

import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import BetItemCashout from "./BetItemCashout";
import BetCardLink from "./card/BetCardLink";
import MyBetsPageBetItemDetails from "./MyBetsPageBetItemDetails";
import AutosellButton from "./cashout/AutosellButton";

export default observer(function BetItem() {
	return (
		<ErrorBoundaryWithPropagation componentName={"Mobile/BetItem.tsx"}>
			<div className="bet bet--mini">
				<div className="bet--mini__body">
					<BetCardLink />

					<div className="bet--mini__actions">
						<BetItemCashout />
						<AutosellButton />
					</div>
				</div>
				<MyBetsPageBetItemDetails />
			</div>
		</ErrorBoundaryWithPropagation>
	);
});
